// extracted by mini-css-extract-plugin
module.exports = {"make-model":"MakeModel_make-model__Nm2jO","skeleton":"MakeModel_skeleton___rl_k"};